import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from './utils/request'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueApexCharts from 'vue-apexcharts'
import * as echarts from 'echarts'
import './style/global.scss'

import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import '@/guard'

Vue.use(VueApexCharts)
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$FileSaver = FileSaver //设置全局
Vue.prototype.$XLSX = XLSX //设置全局
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
